import React from 'react'
import PropTypes from 'prop-types'
import { useLocation } from '@reach/router'

import { Tabs } from '../../atoms/tabs'
import { StyledMenuButton, StyledMenuIconItem } from './styles'
import { useSearchContext } from '../../../context/searchProvider'
import { useDebounce } from '../../../hooks/useDebounce'
import { TabsMenuFallback } from './fallback'
import {
  normalizeDataLayerText,
  pushDataLayer,
} from '../../../utils/pushDataLayer'
import Link from '../../atoms/link'

const TabsCasino = (props) => {
  const { paths, screenName } = props
  const { menu_items } = props.content

  const { openSearch } = useSearchContext()
  const location = useLocation()
  const debouncedOpenSearch = useDebounce(openSearch, 500)

  const onOpenSearch = () => {
    debouncedOpenSearch()

    if (screenName) {
      pushDataLayer({
        eventName: 'search-opened',
        data: {
          location: screenName,
        },
      })
    }
  }

  const onTabClick = (tabName) => {
    if (screenName) {
      pushDataLayer({
        eventName: 'tab-opened',
        data: {
          location: screenName,
          category_name: normalizeDataLayerText(tabName),
        },
      })
    }
  }

  if (!menu_items) return <TabsMenuFallback />

  const createMenuItemByType = (item) => {
    const { icon, title } = item

    let { link } = item
    let isActive = null
    let { pathname } = location
    if (!pathname.endsWith('/')) pathname += '/'

    switch (item.type) {
      case 'search':
        return (
          <StyledMenuButton
            key={icon.url}
            onClick={onOpenSearch}
            aria-label="Search games"
            id="casino-tabs-search"
          >
            <StyledMenuIconItem src={icon.url} alt="Search icon" />
          </StyledMenuButton>
        )
      case 'default':
        link = paths.casino
        isActive = pathname.endsWith(link)
        break
      case 'games':
        link = paths.categoryHome
        isActive =
          !pathname.endsWith(paths.casino) &&
          !pathname.endsWith(paths.promotions) &&
          !pathname.endsWith(paths.ktoClub)
        break
      case 'promotions':
        link = paths.promotions
        isActive = pathname.endsWith(link)
        break
      case 'clube-kto':
        link = isLoggedIn ? paths.ktoClub : `/${loginSlug}/`
        isActive = pathname.endsWith(link)
        break
    }

    const tabName = normalizeDataLayerText(title)

    const id = `casino-tabs-${tabName}`

    return (
      <Link
        to={link}
        id={id}
        data-qa={id}
        key={`${link}-${title}`}
        className={isActive ? 'active' : ''}
        onClick={() => onTabClick(tabName)}
      >
        {title}
      </Link>
    )
  }

  return <Tabs>{menu_items?.map(createMenuItemByType)}</Tabs>
}

TabsCasino.defaultProps = {
  content: {
    menu_items: [],
  },
}

TabsCasino.propTypes = {
  paths: PropTypes.shape({
    casino: PropTypes.string,
    category: PropTypes.string,
    categoryHome: PropTypes.string,
    promotions: PropTypes.string,
    ktoClub: PropTypes.string,
  }).isRequired,
  content: PropTypes.shape({
    menu_items: PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.shape({
          url: PropTypes.string,
          alt: PropTypes.string,
        }),
        title: PropTypes.string,
        type: PropTypes.string,
      })
    ),
  }),
  screenName: PropTypes.string,
}

export { TabsCasino }
